








































import { isEmpty } from "lodash";
import Vue from "vue";

export default Vue.extend({
  name: "BaseStripeTable",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    fetchAction: {
      type: String,
      default: "",
    },
    fetchQuery: {
      type: Object,
      default: () => ({}),
    },
    fetchHeaders: {
      type: Object,
      default: () => ({}),
    },
    loadingGetter: {
      type: String,
      default: "",
    },
    itemsGetter: {
      type: String,
      default: "test",
    },
    paginationGetter: {
      type: String,
      default: "",
    },
    storeNamespace: {
      type: String,
      default: "",
    },
    showExpand: {
      type: Boolean,
      default: false,
    },
    filterOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      expanded: [],
      disabledPrev: false,
      disabledNext: false,
      loading: false,
      query: this.$route.query,
      filters: {},
    };
  },
  computed: {
    options(): any {
      const pagination =
        this.$store.getters[`${this.storeNamespace}/${this.paginationGetter}`];
      return {
        itemsPerPage: pagination.limit,
      };
    },
    computedItems(): [] {
      return this.loading
        ? []
        : this.$store.getters[`${this.storeNamespace}/${this.itemsGetter}`];
    },
  },
  watch: {
    "$route.query": function () {
      this.fetchData();
    },
  },
  created() {
    this.filters = { ...this.filterOptions };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    hasFilters(): boolean {
      return !isEmpty(this.filters);
    },
    getFiltersPayload(): any {
      const payload = {};
      // for (const [key, data] of Object.entries(this.filters)) {
      //   if (!isEmpty(data.value)) {
      //     //payload[key] = data.value;
      //   }
      // }

      return payload;
    },
    fetchData(type?: string): void {
      this.loading = true;
      const query = this.fetchQuery || this.$route.query;
      const payload = {
        type,
        query: {
          ...query,
          ...this.getFiltersPayload(),
        },
        _headers: { ...this.fetchHeaders },
      };

      this.$store
        .dispatch(`${this.storeNamespace}/${this.fetchAction}`, payload)
        .finally(() => {
          // !!! IMPORTANT !!! loading must stop first. Computed functions depend on it.
          this.loading = false;

          const pagination =
            this.$store.getters[
              `${this.storeNamespace}/${this.paginationGetter}`
            ];
          const { limit, has_more } = pagination;

          this.disabledPrev =
            (type === "prev" && has_more === false) || type === undefined;
          this.disabledNext = type === "next" && has_more === false;

          // Disable both if the result set is less than the pagination limit
          const hasNoItems = this.computedItems.length === 0;
          // We CANNOT use <= here because that's what the has_more boolean is for
          const lessThanLimit = this.computedItems.length < limit;

          if (hasNoItems || (lessThanLimit && !this.disabledNext)) {
            this.disabledPrev = true;
            this.disabledNext = true;
          }
        });
    },
    previous() {
      this.fetchData("prev");
    },
    next() {
      this.fetchData("next");
    },
  },
});
